
import Clipboard from 'clipboard'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import store from '../config/store'
import axios from '../http'
import * as commonRights from '@/common/config/rights'
const effectiveRights = require(`@/${process.env.VUE_APP_DOMAIN}/config/rights.js`).default

export default {
  components: {
    MenuIcon: () => import(/* webpackChunkName: "svg" */ `../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-menu.svg`),
    ClipboardIcon: () => import(/* webpackChunkName: "svg" */ `../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-clipboard-copy.svg`),
    DownloadIcon: () => import(/* webpackChunkName: "svg" */ `../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-download.svg`),
    DownloadRibIbanIcon: () => import(/* webpackChunkName: "svg" */ `../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-download-rib.svg`),
    CurrencyIcon: () => import(/* webpackChunkName: "svg" */ `../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-currency.svg`),
    MailIcon: () => import(/* webpackChunkName: "svg" */ `../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-mail-dashboard.svg`)
  },
  
  data: () => ({
    store,
    dropdown: false,
    dashboardInfos: {},
    currentDate: moment().format('DD/MM/YYYY')
  }),
  
  computed: {
    ...mapGetters([
      'operationCategories'
    ]),

    user () {
      return store.data.user
    },
    account () {
      return this.user.account
    },
    avatarUrl () {
      return store.data.user.picture_base64 || ''
    },
    hasInboxRights () {
      return effectiveRights.includes(commonRights.INBOX)
    },
    hasCurrencyRibRights () {
      return effectiveRights.includes(commonRights.RIB)
    },

    unreadMessagesCount () {
      return store.data.user.unread_messages_count
    },

    getAvatarStyle () {
      if (store.data.user.picture_base64) {
        return `background-image: url(${store.data.user.picture_base64})`
      }
      return ''
    }
  },

  watch: {
    'store.data.user.account.uuid': function () {
      this.getDashboardInfos()
    }
  },
  
  mounted () {
    if (!this.operationCategories.length) {
      this.getOperationCategories()
    }
    this.getDashboardInfos()
    this.clipboard = new Clipboard('#rib-copy')
    this.clipboard.on('success', this.onCopySuccess)
  },
  
  methods: {
    ...mapActions([
      'getOperationCategories'
    ]),

    onToggleSidebar () {
      document.getElementById('sidebar').classList.toggle('is-open')
    },
    onCopySuccess () {
      this.showBanner('success', this.$i18n.t('banner.success.iban_copied'))
    },
    downloadRib () {
      this.downloadFileFromUrl('/account/rib')
    },
    getDashboardInfos () {
      axios.get('/dashboard').then(response => {
        this.dashboardInfos = response.data
      })
    },
    showDetails (operation) {
      if (operation.intraday_id) {
        return null
      }
      this.showSidePanel({
        childVue: 'operation-detail',
        dataModel: operation,
        wrapperClass: 'sidepanel--md',
      })
    },
    
    showCustomerInfos () {
      this.showModal({
        childVue: 'customer-infos',
        dataModel: {},
        wrapperClass: 'modal--sm',
      })
    }
  }
}
